module.exports = __webpack_public_path__ + "static/social-2c-aeb48ad48c0d27fd82e93d66624b24cf.svg";